
$(function () {
	var FadeIn = {
		standby: function () {
			this.view = {};
			this.view.window = $(window);
			this.view.window.on("scroll", this.fadeUp.bind(this));
			this.view.window.on("scroll", this.fadeIn.bind(this));
		},
		fade: function () {
			$(".fade").each(function () {
				$(this).addClass("js-fade");
			});
		},
		fadeUp: function (el) {
			const fade_bottom = 200; // 画面下からどの位置でフェードさせるか(px)
			const scroll_top = $(el.currentTarget).scrollTop();
			const scroll_bottom = scroll_top + $(el.currentTarget).height();
			const fade_position = scroll_bottom - fade_bottom;

			$(".fadeIn").each(function () {
				const this_position = $(this).offset().top;
				if (fade_position > this_position) {
				$(this).addClass("js-fade");
				}
			});
		},
		fadeIn: function (el) {
			var headerH = $(".l-container-header").outerHeight();
			if ($(el.currentTarget).scrollTop() > headerH) {
				$(".sticky-banner").addClass("is-show");
			} else {
				$(".sticky-banner").removeClass("is-show");
			}
		}
	};
	FadeIn.standby();

	var Slide = {
		init: function () {
			this.view = {};
			this.view.slider = $(".slider");

			this.view.slider.slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				dots: true,
				centerMode: true,
				centerPadding: "267px",

				responsive: [
					{
						breakpoint: 769,
						settings: {
							centerPadding: "5%",
						},
					},
				],
			});
		},
	};
	Slide.init();
	var Accordion = {
		standby: function () {
			this.view = {};
			this.view.accordion = $(".js-accordion");
			this.view.accordion.on("click", this.openAccordion.bind(this));
		},

		openAccordion: function (el) {
			var findElm = $(el.currentTarget).next(".js-open");
			$(el.currentTarget).toggleClass('js-active');
			$(findElm).slideToggle();
		}
	};
	Accordion.standby();

	var OpenSpMenu = {
		standby: function () {
			this.view = {};
			this.view.spMenuIcon = $(".hamb");
			this.view.spMenuIcon.on("click", this.openMenu.bind(this));
			this.view.spMenuList = $(".header_nav_link");
			this.view.spMenuList.on("click", this.closeMenu.bind(this));
		},

		openMenu: function (el) {
			$(el.currentTarget).toggleClass('js-active');
			$(el.currentTarget).next('.js-Menu').toggleClass('js-active');
		},
		closeMenu: function (el) {
			$(".hamb").removeClass("js-active");
			$(el.currentTarget).parents(".js-Menu").removeClass("js-active");
		}
	}
	OpenSpMenu.standby();

	var StickyBanner = {
		standby: function () {
			this.view = {};
			this.view.closeIcon = $(".js-close");
			this.view.closeIcon.on("click", this.closeBanner.bind(this));
		},
		closeBanner: function (el) {
			$(el.currentTarget).parents(".sticky-banner").addClass("hide");
		}
	}
	StickyBanner.standby();

})
